import { APIRoute } from '@/modules/utils'

export const Route: APIRoute = {
  method: 'POST',
  path: '/v2/identity/check-mrz',
}

export type Body = {
  line1: string
  line2: string
}

export type Response = never
